import { SHOP_URL } from '../config';

export const getShopUrl = (userEmail: string) => {
  if (userEmail) {
    const encodedEmail = encodeURIComponent(userEmail);
    return `${SHOP_URL}?uemail=${encodedEmail}`;
  }

  return SHOP_URL;
};
